import instance from './base';

export async function getPlaces() {
  return [
    {
      id: 1,
      text: '館別A',
      spaces: [{
        id: 1,
        text: '空間1',
      }, {
        id: 2,
        text: '空間2',
      }],
    },
    {
      id: 2,
      text: '館別B',
      spaces: [{
        id: 1,
        text: '空間2-1',
      }, {
        id: 2,
        text: '空間2-2',
      }],
    },
  ];
}

export async function addPlace() {
  return true;
}

const fakeBranches = [
  {
    id: 1,
    name: '館別1',
    public: true,
    rooms: [
      {
        id: 3,
        name: '空間1',
        public: true,
      },
      {
        id: 4,
        name: '空間2',
        public: false,
      },
    ],
  },
  {
    id: 2,
    name: '館別2',
    public: false,
    rooms: [
      {
        id: 5,
        name: '空間1',
        public: true,
      },
      {
        id: 6,
        name: '空間2',
        public: true,
      },
    ],
  },
];
let maxID = 2;

export async function getBranches(publicStatus) {
  if (window.mockMode) {
    return fakeBranches;
  }
  const rsp = await instance.get('/v1/branches', {
    params: {
      public: publicStatus,
    },
  });
  rsp.data.sort((a, b) => {
    if (a.rank && b.rank) {
      return a.rank - b.rank;
    }
    if (a.rank && !b.rank) {
      return -1;
    }
    if (!a.rank && b.rank) {
      return 1;
    }
    return a.name.localeCompare(b.name);
  });
  return rsp.data;
}

export async function addBranch(name, publicStatus, rooms) {
  const data = {
    name,
    public: publicStatus,
    rooms,
  };
  if (window.mockMode) {
    maxID += 1;
    fakeBranches.push({
      ...data,
      id: maxID,
    });
    return { id: maxID };
  }
  const rsp = await instance.post('/v1/branches', data);
  return rsp.data;
}

// 後端 PUT /v1/branches/:id 沒帶 receipt_* 時會把收據圖片清成空字串，
// 所以一般編輯也要把既有的圖片 id 原樣送回
function receiptImageIDs(branch) {
  return {
    receipt_logo: branch?.receipt_logo?.id,
    receipt_seal: branch?.receipt_seal?.id,
    receipt_stamp_seal: branch?.receipt_stamp_seal?.id,
    receipt_position_image: branch?.receipt_position_image?.id,
  };
}

export async function updateBranch(id, name, publicStatus, origRooms, newRooms, notificationName, mapURL, origBranch) {
  const data = {
    name,
    public: publicStatus,
    added_rooms: newRooms.map((n) => ({
      name: n,
      public: true,
    })),
    updated_rooms: origRooms,
    notification_name: notificationName,
    map_url: mapURL,
    ...receiptImageIDs(origBranch),
  };
  if (window.mockMode) {
    fakeBranches.forEach((b) => {
      if (b.id === id) {
        // eslint-disable-next-line no-param-reassign
        b.rooms = [];
        b.rooms.push(...origRooms);
        b.rooms.push(...newRooms);
        // eslint-disable-next-line no-param-reassign
        b.name = name;
        // eslint-disable-next-line no-param-reassign
        b.public = publicStatus;
      }
    });
    return {};
  }

  const rsp = await instance.put(`/v1/branches/${id}`, data);
  return rsp.data;
}

export async function updateBranchCustom(origData, chargePerson, generatedBy, logo, seal, stamp, position) {
  const data = {
    name: origData.name,
    public: origData.public,
    updated_rooms: origData.rooms,
    receipt_charge_person: chargePerson,
    receipt_generated_by: generatedBy,
    receipt_logo: logo,
    receipt_seal: seal,
    receipt_stamp_seal: stamp,
    receipt_position_image: position,
    notification_name: origData.notification_name,
    map_url: origData.map_url,
  };

  const rsp = await instance.put(`/v1/branches/${origData.id}`, data);
  return rsp.data;
}

export async function createLogo(file) {
  const formData = new FormData();
  formData.append('logo', file);
  const rsp = await instance.post('/v1/branches/logo', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return rsp.data;
}

export async function createSeal(file) {
  const formData = new FormData();
  formData.append('seal', file);
  const rsp = await instance.post('/v1/branches/seal', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return rsp.data;
}

export async function createStamp(file) {
  const formData = new FormData();
  formData.append('stamp', file);
  const rsp = await instance.post('/v1/branches/stamp', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return rsp.data;
}

export async function createPosition(file) {
  const formData = new FormData();
  formData.append('position', file);
  const rsp = await instance.post('/v1/branches/position', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return rsp.data;
}

// HASH_KEY／HASH_IV 只在使用者輸入新值時才送出；沒送的欄位後端會保留原值。
// merchantID 傳空字串代表清除此館別的藍新設定。
export async function updateBranchNewebpay(origData, merchantID, hashKey, hashIV) {
  const data = {
    newebpay_merchant_id: merchantID,
  };
  if (hashKey) {
    data.newebpay_hash_key = hashKey;
  }
  if (hashIV) {
    data.newebpay_hash_iv = hashIV;
  }

  const rsp = await instance.post(`/v1/branches/${origData.id}/newebpay`, data);
  return rsp.data;
}
